module.exports = __webpack_public_path__ + "static/oktoberfeast-487c99cde6f26259fdc86896a9ff4a46.jpeg";